import { useEffect, useRef } from "react";

export default function Particles({ density = 16000, className = "" }) {
    const ref = useRef(null);

    useEffect(() => {
        const canvas = ref.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        let raf;
        let particles = [];
        let w = 0;
        let h = 0;

        const resize = () => {
            const rect = canvas.parentElement.getBoundingClientRect();
            w = rect.width;
            h = rect.height;
            canvas.width = w * dpr;
            canvas.height = h * dpr;
            canvas.style.width = `${w}px`;
            canvas.style.height = `${h}px`;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            const n = Math.max(28, Math.min(90, Math.floor((w * h) / density)));
            particles = Array.from({ length: n }, () => ({
                x: Math.random() * w,
                y: Math.random() * h,
                r: 0.6 + Math.random() * 1.7,
                vy: -(0.08 + Math.random() * 0.32),
                vx: (Math.random() - 0.5) * 0.12,
                p: Math.random() * Math.PI * 2,
                s: 0.008 + Math.random() * 0.016,
            }));
        };

        resize();
        window.addEventListener("resize", resize);
        const tick = () => {
            ctx.clearRect(0, 0, w, h);
            for (const pt of particles) {
                pt.y += pt.vy;
                pt.x += pt.vx;
                pt.p += pt.s;
                if (pt.y < -12) {
                    pt.y = h + 12;
                    pt.x = Math.random() * w;
                }
                const a = 0.2 + Math.abs(Math.sin(pt.p)) * 0.55;
                ctx.beginPath();
                ctx.arc(pt.x, pt.y, pt.r, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(245, 197, 66, ${a})`;
                ctx.fill();
            }
            raf = requestAnimationFrame(tick);
        };
        tick();
        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener("resize", resize);
        };
    }, [density]);

    return <canvas ref={ref} className={className} aria-hidden="true" />;
}
